import { ButtonClose } from "../ui"; // Componente de botón reutilizable para cerrar el popup
import { PopupProps } from "@/types"; // Tipos para los props del popup
import { PopupStilosCss } from "../styles"; // Estilos CSS específicos para este tipo de popup

/**
 * Componente PopupPagoPaso2
 * 
 * Modal utilizado para mostrar información del pago en el paso 2.
 * Incluye fondo semitransparente, contenido centralizado y botón de cerrar.
 * 
 * @param {PopupProps} props
 * @param {boolean} props.isOpen - Indica si el popup está visible.
 * @param {() => void} props.onClose - Función para cerrar el popup.
 * @param {React.ReactNode} props.children - Contenido que se mostrará dentro del popup.
 * @param {string} [props.className] - Clases CSS adicionales opcionales.
 */
const PopupPagoPaso2: React.FC<PopupProps> = ({ isOpen, onClose, children, className }) => {

  // Si isOpen es false, no renderiza nada
  if (!isOpen) return null;

  return (
    // Contenedor que cubre toda la pantalla
    // fixed + inset-0: ocupa todo el viewport
    // flex items-center justify-center: centra el popup
    // bg-black bg-opacity-80: fondo negro semitransparente
    // z-50: se coloca sobre otros elementos
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">

      {/* Contenedor del contenido del popup */}
      {/* Combina clases dinámicas, estilos específicos y diseño responsive */}
      <div className={`${className} ${PopupStilosCss.popupPagoDatos} 
        bg-white shadow-xl rounded-md p-4 relative w-10/12 md:w-4/12 max-h-[95vh] `}
      >
        {/* Contenido del popup */}
        {children}

        {/* Botón de cerrar en la esquina superior derecha */}
        <ButtonClose
          onClick={onClose}
          className="absolute top-1 right-2 rounded-full"
        />
      </div>
    </div>
  );
};

export default PopupPagoPaso2;
